import type { APIErrorBody } from '../types'

export const API_URL = (import.meta.env.VITE_API_URL ?? 'http://127.0.0.1:8787').replace(/\/$/, '')

export class APIError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code: string,
  ) {
    super(message)
    this.name = 'APIError'
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers)
  if (init.body && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json')
  const response = await fetch(`${API_URL}${path}`, {
    ...init,
    headers,
    credentials: 'include',
  })
  if (!response.ok) {
    let body: APIErrorBody | undefined
    try {
      body = await response.json() as APIErrorBody
    } catch {
      // A reverse proxy may return a non-JSON infrastructure error.
    }
    throw new APIError(body?.error.message ?? `Request failed (${response.status})`, response.status, body?.error.code ?? 'REQUEST_FAILED')
  }
  if (response.status === 204) return undefined as T
  return response.json() as Promise<T>
}

export const fetcher = <T>(path: string) => api<T>(path)

